<div class="container">
  <div class="row">
    <div class="col s12 m6 l4 push-m3 push-l4">
      <!-- RECOVER PASSWORD FORM REQUEST DIALOG -->
      <mat-card *ngIf="!hasSubmitted; else emailSent">
        <mat-card-header>
          <mat-card-title>Forgot Password</mat-card-title>
          <mat-card-subtitle>
            Please enter your email address below, and we’ll send you a temporary password.
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="container">
            <small class="text-bold text-block text-upper text-align-right">*required field</small>

            <form class="form" [formGroup]="form" (submit)="onSubmit($event)">
              <div class="form-wrapper">
                <mat-form-field>
                  <input matInput name="email" placeholder="Email Address" formControlName="email" required />
                  <mat-error *ngIf="form.controls.email.errors?.required">
                    <fa-icon icon="exclamation-triangle"></fa-icon> Email address is required.
                  </mat-error>
                  <mat-error *ngIf="!form.controls.email.errors?.required && form.controls.email.errors?.email">
                    <fa-icon icon="exclamation-triangle"></fa-icon> Invalid Email address.
                  </mat-error>
                </mat-form-field>
              </div>

              <span class="btn-group btn-group--wrap">
                <button class="btn btn-primary" name="reset-password" type="submit" [disabled]="isLoading">
                  Submit
                  <fa-icon *ngIf="isLoading" icon="spinner" [spin]="true"></fa-icon>
                </button>
                <a routerLink="/" class="btn btn-link">Return to login</a>
              </span>
            </form>
          </div>
        </mat-card-content>
        <mat-card-footer class="no-divider">
          <p class="text-align-left">
            If you do not receive an email from us, or if you need further assistance, please contact our
            <a routerLink="/contact-us">Customer Support</a> team.
          </p>
        </mat-card-footer>
      </mat-card>

      <!-- RECOVER PASSWORD CONFIRMATION DIALOG -->
      <ng-template #emailSent>
        <mat-card>
          <mat-card-header class="no-divider">
            <mat-card-title>Forgot Password</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="container">
              <p>Thank you! An email has been sent to you with your temporary password.</p>
              <p>
                If you do not receive an email from us, or if you need further assistance, please contact our
                <a routerLink="/contact-us">Customer Support</a> team.
              </p>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <a routerLink="/" class="btn btn-link">Return to login</a>
          </mat-card-actions>
        </mat-card>
      </ng-template>
    </div>
  </div>
</div>
